/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Order_Confirm_Delivery_SuccessInputs */

const vi_toast_order_confirm_delivery_success = /** @type {(inputs: Toast_Order_Confirm_Delivery_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận giao hàng thành công`)
};

/**

* @param {Toast_Order_Confirm_Delivery_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_order_confirm_delivery_success = /** @type {((inputs?: Toast_Order_Confirm_Delivery_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Order_Confirm_Delivery_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_order_confirm_delivery_success(inputs)
});